export const focusElement = (element: Element) => {
    if ('focus' in element && typeof element.focus === 'function') {
        element.focus();
    }
};
